const Footer = () => (
  <footer className="border-t border-slate-200 bg-white py-6 dark:border-slate-800 dark:bg-slate-900">
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 text-sm text-slate-500 dark:text-slate-400 md:flex-row">
      <span>© {new Date().getFullYear()} Ferramentas Dev Suite</span>
      <a
        href="https://github.com/UpLandHammer"
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-full border border-slate-200 px-4 py-2 font-medium text-slate-600 transition hover:border-brand-primary hover:text-brand-primary dark:border-slate-700 dark:text-slate-300 dark:hover:border-brand-primary dark:hover:text-brand-primary"
      >
        GitHub do desenvolvedor: UpLandHammer
      </a>
    </div>
  </footer>
);

export default Footer;
